export const TOAST_MESSAGES = {
    MIN_CODE_REQUIRED: '최소 1개의 공통코드는 필요합니다.',
    LOGIN_NOT_FOUND: '로그인 정보를 찾을 수 없습니다.',
    GROUP_SAVE_FAIL: '그룹코드 저장에 실패했습니다.',
    NO_CHANGES: '변경사항이 없습니다.',
    SAVE_SUCCESS: (isEdit: boolean) => isEdit ? '공통코드가 수정되었습니다.' : '공통코드가 추가되었습니다.',
    SAVE_FAIL: (isEdit: boolean) => isEdit ? '공통코드 수정에 실패했습니다.' : '공통코드 추가에 실패했습니다.',
} as const;

export const VALIDATION_MESSAGES = {
    GRP_CODE_REQUIRED: '그룹코드를 입력해주세요.',
    GRP_NAME_REQUIRED: '그룹명을 입력해주세요.',
    COM_CODE_REQUIRED: (index: number) => `공통코드 ${index}의 공통코드를 입력해주세요.`,
    COM_NAME_REQUIRED: (index: number) => `공통코드 ${index}의 공통코드명을 입력해주세요.`,
} as const;

export const DEFAULT_VALUE_FIELDS = 2;
export const MAX_VALUE_FIELDS = 5;

export const GROUP_TABLE_HEADERS = ['그룹코드', '그룹명', '그룹값', '관리', ''] as const;
export const CODE_TABLE_HEADERS = ['공통코드', '공통코드명', '사용여부', '코드값1', '코드값2', '코드값3', '코드값4', '코드값5'] as const;

export const EMPTY_MESSAGES = {
    NO_GROUPS: '그룹이 없습니다.',
    NO_CODES: '공통코드가 없습니다.',
} as const;

export const LOADING_MESSAGES = {
    GROUPS: '그룹 목록을 불러오는 중...',
    CODES: '공통코드를 불러오는 중...',
} as const;
